import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { usePage } from '../hooks/usePage.js';
import { AlumniRegistrationForm } from '../components/AlumniRegistrationForm.jsx';

/**
 * Public alumni self-registration page (/alumni/register). Header + banner come
 * from the `alumni` page row so the admin controls the banner image.
 */
export function AlumniRegistrationPage() {
  const head = usePage('alumni');

  return (
    <>
      <Seo
        title="Alumni registration"
        description="Former Maple Leaf students — register with the alumni network to hear about events, mentoring and reunions."
      />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Alumni', to: '/alumni' }, { label: 'Register' }]}
        headline="Join the *alumni network*"
        lede="Once a Maple Leaf, always a Maple Leaf. Tell us where you are now and we'll keep you connected."
        image={head.banner}
      />

      <section>
        <div className="container" style={{ maxWidth: 860 }}>
          <AlumniRegistrationForm />
        </div>
      </section>
    </>
  );
}
